import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Input as FormInput } from '../../../../Form/index';
import './../ExperienceListItem.css';
import { Button } from '../../../../Button';
import {
  withInputClassNames,
  withTextAreaClassNames,
} from './../../../../EditProfile/HOC';

const Input = withInputClassNames(FormInput);
const TextArea = withTextAreaClassNames(FormInput);

const ExperienceListItemForm = ({ isValid, handleSubmit }) => (
  <div className="col-12 px-7 py-5">
    <div className="form-row">
      <Input inputClassName="form-t" label="Job Title" name="job_title" />
      <Input label="Company" name="company_name" />
    </div>
    <div className="form-row">
      <TextArea label="Job Description" name="job_description" />
    </div>
    <div className="form-row text-right">
      <Button
        className="t-14"
        title="Save"
        onClick={handleSubmit}
        transparent
        withoutTextTransform
        disabled={!isValid}
      />
    </div>
  </div>
);

ExperienceListItemForm.propTypes = {
  handleSubmit: PropTypes.func,
  isValid: PropTypes.bool,
};

const validationSchema = Yup.object().shape({
  job_title: Yup.string().required('Job title is required'),
  job_description: Yup.string().required('Job description is required'),
});

const mapPropsToValues = ({ experience }) => experience;

export default withFormik({
  handleSubmit: (values, { props, setSubmitting }) => {
    props
      .handleUpdateExperience(values, setSubmitting)
      .then(() => props.changeEditionState());
  },
  enableReinitialize: true,
  validateOnBlur: true,
  validateOnChange: true,
  isInitialValid: props =>
    validationSchema.isValidSync(mapPropsToValues(props)),
  mapPropsToValues,
  validationSchema,
  displayName: 'ExperienceListItemForm',
})(ExperienceListItemForm);



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/ExperienceList/ExperienceListItem/ExperienceListItemForm/ExperienceListItemForm.js